goog.module('yextschema.NoOpAnalytics');
goog.module.declareLegacyNamespace();

/**
 * @fileoverview Provides the NoOpAnalytics class that exposes the same interface as Analytics, but
 *               does nothing. It's used when the noAnalytics flag is set.
 *
 * @author Eugene Gurevich (egurevich@yext.com)
 *
 * Note: The interface of NoOpAnalytics should be kept in sync with the the real Analytics class.
 */

class NoOpAnalytics {
  event(eventName, entityId) {
    // Nothing to do
  }
}

exports = NoOpAnalytics;
